<template>
	<jc-page>
		<view class="my-box">
			<!-- 用户 -->
			<image src="/static/my_bg.png" :style="imageStyle"></image>
			<view :style="titleStyle"></view>
			<view class="user-panel-box" :style="userPanelStyle">
			<!-- 未登录 -->
			<view class="u-flex">
				<view class="u-m-r-20" style="float: left;"><u-avatar size="70" class="u-m-l-20" :src="fnImgRequestPath(data.membInfoBo.headImgUrl)" mode="square"> </u-avatar></view>
				<view class="f_r_e_s" style="overflow: hidden; margin-top:10px;padding-bottom: 10px;">
					<view class="u-font-lg" v-if="data.membType==1">{{ data.membInfoBo.membUserName}}</view>
					<view class="u-font-lg" :style="{color : vuex_skinColor}" @click="fnGoToLogin" v-if="!vuex_hasLogin">点击登录</view>
					<view class="u-font-lg" v-if="data.membType==0&&vuex_hasLogin">{{ data.membInfoBo.membUserName}}</view>
					<view class="level" v-if="data.membType==1">{{ data.membInfoBo.gradeName }}</view>
					<view class="level " v-if="data.membType==1">{{data.membInfoBo.starGradeName}}</view>
				</view>
				<!--<view><u-icon name="arrow-right" color="#969799" size="28"></u-icon></view>-->
				<view class="num f_r_c_sb" v-if="data.membType==1">
					<view>会员编号:<text style="margin-left: 10rpx;">{{data.membInfoBo.membNum}}</text></view>
					<view class="bhsj f_r_c_c" @click.stop="handleBtnRegisterTap" v-if="data.canUpgrade">
						<text style="font-size: 17px; " v-if="data.isShowReplenish && data.isFrozen != 1" >补货升级</text>
						<text style="font-size: 17px;" v-if="data.membType==0" hidden="hidden">注册会员</text>
						<image src="/static/images/my-icon.png" v-if="(data.isShowReplenish||data.membType==0) && data.isFrozen != 1" style="width:50rpx; height: 50rpx; margin-left:10rpx;"></image>
					</view>
				</view>
				<view class="num f_r_c_sb" style="font-weight: unset;font-size: 30rpx !important;" v-if="!vuex_hasLogin">
					<view>登录解锁更多完整权益</view>
				</view>
				</view>
			</view>
			<AnnounceNew :announceList="data.announceInfoList" @announce-click="goAnnounceDetail"></AnnounceNew>
			<MiddleImage></MiddleImage>
			<MyAccountInput
				v-if="showAccountModal"
				:showSecPasswordModal="showAccountModal"
				@account-close="handlerOnClose"
				@account-confirm="handlerOnConfirm"
				@on-password-input="handlerInputPassWord"
				:secondData="secondData"
			></MyAccountInput>
			<u-gap height="10"></u-gap>
			<!-- 订单 -->
			<view class="panel-box">
				<view class="nav_my_top" @click="fnGotoOrderPage(0)">
					<view class="nav_my_order_all">
						<span style="font-size: 15px;">查看全部</span>
						<image :src="fnStaticRequestPath('icon/37.png')"
							class='go_to_icon'></image>
					</view>
					<text class="nav_my_top_tit">我的订单</text>
				</view>
				<u-grid :col="5" :border="false" class="panel-main" style="width:100%">
					<u-grid-item  @click="fnGotoOrderPage(1)">
						<image src="/static/images/21.png" style="width: 25px; height: 25px;"></image>
						<text class="nav_list_num" v-if="data.orderInfoBo.dfkNum>0">{{data.orderInfoBo.dfkNum}}</text>
						<text style="margin-top: 5px;">待付款</text>
					</u-grid-item>
					<u-grid-item  @click="fnGotoOrderPage(33)">
						<image src="/static/images/dth.png" style="width: 25px; height: 25px;"></image>
						<text class="nav_list_num" v-if="data.orderInfoBo.dthNum>0">{{data.orderInfoBo.dthNum}}</text>
						<text style="margin-top: 5px;">待提货</text>
					</u-grid-item>
					<u-grid-item  @click="fnGotoOrderPage(2)">
						<image src="/static/images/31.png" style="width: 25px; height: 25px;">
						</image>
						<text class="nav_list_num" v-if="data.orderInfoBo.dfhNum>0">{{data.orderInfoBo.dfhNum}}</text>
						<text style="margin-top: 5px;">待发货</text>
					</u-grid-item>
					<u-grid-item  @click="fnGotoOrderPage(3)"><image src="/static/images/32.png" style="width: 25px; height: 25px;"></image>
						<text class="nav_list_num" v-if="data.orderInfoBo.yfhNum>0">{{data.orderInfoBo.yfhNum}}</text>
						<text style="margin-top: 5px;">待收货</text>
					</u-grid-item>
					<u-grid-item  @click="fnGotoOrderPage(4)"><image src="/static/images/33.png" style="width: 25px; height: 25px;"></image>
						<text class="nav_list_num" v-if="data.orderInfoBo.dpjNum>0">{{data.orderInfoBo.dpjNum}}</text>
						<text style="margin-top: 5px;">待评价</text>
					</u-grid-item>
				</u-grid>
			</view>
			<view class="panel-box" style="margin-top: 10px; margin-bottom: 20px;" v-if="data.isHelpOrder == 0">
				<view class="panel-header" style="border-bottom: none;">
					<text class="nav_my_top_tit">工具/服务</text>
				</view>
				<view v-if="data.membType==1">
					<u-grid :col="5" :border="false" >
						<u-grid-item style="margin-top:15px" @click="fnOpenVipRegister" v-if="data.membType==1&&data.isFrozen != 1"><image src="/static/images/login_id_card.png" style="width: 25px; height: 25px;"></image><text style="margin-top: 10px;">会员注册</text></u-grid-item>
						<u-grid-item style="margin-top:15px" @click="fnOpenMyTeam" v-if="data.membType==1"><image src="/static/images/new2_07.jpg" style="width: 25px; height: 25px;"></image><text style="margin-top: 10px;">我的客户</text></u-grid-item>
						<u-grid-item style="margin-top:15px" @click="fnMyAccount" v-if="data.membType==1"><image src="/static/images/new2_13.jpg" style="width: 25px; height: 25px;"></image><text style="margin-top: 10px;">我的账户</text></u-grid-item>
						<u-grid-item style="margin-top:15px" @click="navigateTo('/pages/sharePoster/sharePosters')" v-if="data.membType==1"><image src="/static/images/28.png" style="width: 25px; height: 25px;"></image><text style="margin-top: 10px;">邀请好友</text></u-grid-item>
						<u-grid-item style="margin-top:15px" @click="navigateTo('/pages/address/list')"><image src="/static/images/27.png" style="width: 25px; height: 25px;"></image><text style="margin-top: 10px;">地址管理</text></u-grid-item>
						<u-grid-item style="margin-top:15px" v-if="data.storeInfo.enableCertification == 1" @click="navigateTo('/pages/help/help')"><image src="/static/images/login_chat.png" style="width: 25px; height: 25px;"></image><text style="margin-top: 10px;">产品问答</text></u-grid-item>
						<u-grid-item style="margin-top:15px" @click="myPersonal" v-if="data.membType==1"><image src="/static/images/23.png" style="width: 25px; height: 25px;"></image><text style="margin-top: 10px;">个人信息</text></u-grid-item>
						<u-grid-item style="margin-top:15px" v-if="data.isHelpOrder == 0" @click="navigateTo('/pages/set/set')"><image src="/static/images/30.png" style="width: 25px; height: 25px;"></image><text style="margin-top: 10px;">设置</text></u-grid-item>
						<u-grid-item style="margin-top:15px" @click='fnMytraceabilityCode' v-if="data.membType==1"><image src="/static/images/zhuisu.png" style="width: 25px; height: 25px;"></image><text style="margin-top: 10px;" >追溯码 </text></u-grid-item>
						<u-grid-item @click='fnMytraceabilityAnti' v-if="data.membType==1" style="margin-top:15px"><image src="/static/images/fangwei.png" style="width: 25px; height: 25px;"></image><text style="margin-top: 10px;" >防伪码</text></u-grid-item>
					</u-grid>
					<!-- <u-grid :col="5" :border="false">
						<u-grid-item style="margin-top:15px" v-if="data.storeInfo.enableCertification == 1" @click="navigateTo('/pages/help/help')"><image src="/static/images/login_chat.png" style="width: 25px; height: 25px;"></image><text style="margin-top: 10px;">产品问答</text></u-grid-item>
						<u-grid-item style="margin-top:15px" @click="myPersonal" v-if="data.membType==1"><image src="/static/images/23.png" style="width: 25px; height: 25px;"></image><text style="margin-top: 10px;">个人信息</text></u-grid-item>
						<u-grid-item style="margin-top:15px" v-if="data.isHelpOrder == 0" @click="navigateTo('/pages/set/set')"><image src="/static/images/30.png" style="width: 25px; height: 25px;"></image><text style="margin-top: 10px;">设置</text></u-grid-item>
						<u-grid-item style="margin-top:15px" @click='fnMytraceabilityCode' v-if="data.membType==1"><image src="/static/images/zhuisu.png" style="width: 25px; height: 25px;"></image><text style="margin-top: 10px;" >追溯码 </text></u-grid-item>
						<u-grid-item @click='fnMytraceabilityAnti' v-if="data.membType==1" style="margin-top:15px"><image src="/static/images/fangwei.png" style="width: 25px; height: 25px;"></image><text style="margin-top: 10px;" >防伪码</text></u-grid-item>
						
					</u-grid> -->
					<u-grid :col="5" :border="false">
					</u-grid>
				</view>
				<view v-if="data.membType==0">
					<u-grid :col="5" :border="false" >
						<u-grid-item style="margin-top:15px" @click="goAddressList"><image src="/static/images/27.png" style="width: 25px; height: 25px;"></image><text style="margin-top: 10px;">地址管理</text></u-grid-item>
						<u-grid-item style="margin-top:15px" @click="goCustomer" v-if="data.isHelpOrder == 0"><image src="/static/images/29.png" style="width: 25px; height: 25px;"></image><text style="margin-top: 10px;">在线客服</text></u-grid-item>
						<u-grid-item style="margin-top:15px" v-if="data.storeInfo.enableCertification == 1" @click="goHelp"><image src="/static/images/login_chat.png" style="width: 25px; height: 25px;"></image><text style="margin-top: 10px;">产品问答</text></u-grid-item>
						<u-grid-item style="margin-top:15px" v-if="data.isHelpOrder == 0"  @click="goSet"><image src="/static/images/30.png" style="width: 25px; height: 25px;"></image><text style="margin-top: 10px;">设置</text></u-grid-item>
					</u-grid>
				</view>
			</view>
			<!--<u-gap height="20"></u-gap>
			<!- -钱包 -->
			<!--<view class="card-box">
				<u-grid :col="5" :border="false">
					<u-grid-item>
						<view class="u-font-xl">{{ list.model.wallet.integral }}</view>
						<view class="u-font-xs u-m-t-10">积分</view>
					</u-grid-item>
					<u-grid-item>
						<view class="u-font-xl">{{ list.model.wallet.coupon }}</view>
						<view class="u-font-xs u-m-t-10">优惠券</view>
					</u-grid-item>
					<u-grid-item>
						<view class="u-font-xl">{{ list.model.wallet.redPacket }}</view>
						<view class="u-font-xs u-m-t-10">红包</view>
					</u-grid-item>
					<u-grid-item>
						<view class="u-font-xl">{{ list.model.wallet.money }}</view>
						<view class="u-font-xs u-m-t-10">余额</view>
					</u-grid-item>
					<u-grid-item class="all-order">
						<image class="cut-off-line" src="/static/user/cut_off_line.png" mode=""></image>
						<u-icon name="order" label="我的钱包" size="48" label-size="22" margin-top="14" label-pos="bottom"></u-icon>
					</u-grid-item>
				</u-grid>
			</view>
			<u-gap height="20"></u-gap>
			<!- - 其它 -->
			<!--<view class="other-panel-box">
				<u-cell-group :border="list.border">
					<view class="panel-main">
						<u-cell-item
							:title="item.title"
							:value="item.value"
							@click="handleClick(item.eventName,item.param)"
							:border-bottom="list.borderBottom"
							v-for="(item, index) in cells"
							:key="index"
						></u-cell-item>
					</view>
				</u-cell-group>
			</view>-->
			<view class="cu-tabbar-height"></view>
		</view>
	</jc-page>
</template>

<script setup>
	import { onLoad, onShow } from '@dcloudio/uni-app';
	import { getCurrentInstance, reactive, ref, computed} from "vue";
	import { getAnnounceInfoThreeNew, insertBaseAnnounceReadHistory, checkSecPassWord } from '@/api/mine/mine.js'
	import AnnounceNew from '@/pages/mine/announceNew.vue';// 最新三条公告组件
	import MiddleImage from '@/pages/mine/middleImage.vue';// 中间图片组件
	import MyAccountInput from '@/pages/mine/myAccountInput.vue';
	import {getMembInfoByIdApi} from "../../api/memb/membInfo";
	import {fnShowErrorToast, fnIsNull, fnNvl, fnImgRequestPath, fnStaticRequestPath} from "../../utils/utils";
	import {getBaseSystemSetInfoByPlatId} from "../../api/base/baseRuleSet";
	import {countOrderInfo} from "../../api/order/orderInfo";
	// 中间图片组件
	
	const { ctx } = getCurrentInstance(); //获取上下文实例，ctx=vue2的this

	// 页面数据
	const data = reactive({
		isFrozen: 0,// 是否冻结
		membType: 0, // 会员类型，默认为1(正式会员)
		isHelpOrder: 0, // 是否帮助订单，默认为0(不帮助)
		storeInfo: {
			enableCertification: 1 // 是否启用认证，默认为1(启用)
		},//库存信息
		membInfoBo: {

		},//会员信息
		announceInfoList: [],//公告列表
		orderInfoBo:[] //订单信息
	});
	
	// 控制二级密码弹窗显示状态
	const showAccountModal = ref(false);
	
	// 二级密码相关数据
	const secondData = ref({
		showSecPasswordModal: false,// 是否显示二级密码输入框
		secPasswordInputFocus: true,// 二级密码输入框是否聚焦
		inputSecPassword: '',// 二级密码输入框收集输入数据
		secPasswordError: false,// 二级密码输入错误提示信息
		passwordError: false,//二级密码输入错误控制是否显示
		passwordErrorMsg: '',// 二级密码输入错误提示信息
		goToType:0,//跳转类型:0 我的客户 1 个人信息 2 悦享专区业绩 3 健康优库业绩
	})
	
	// 背景样式设置
	const background= reactive({
		// 导航栏高度(不包括状态栏高度在内，内部自动加上)，注意这里的单位是px
		height: '220px',
		// 导航栏背景图
		background: 'url(https://cdn.uviewui.com/uview/swiper/1.jpg) no-repeat',
		// 还可以设置背景图size属性
		backgroundSize: 'cover',
	});
	
	// 图片路径
	const pic = ref('https://uviewui.com/common/logo.png')
	
	// 控制显示状态
	const show = ref(true)
	
	// 列表数据
	const list = reactive({
		border: false,
		borderBottom: false,
		model: {
			user: {
				/* 图像 */
				userFace: '',
				/* 昵称 */
				nickName: '',
				/* 标签 */
				userTag: ['钻石会员', '达人']
			},
			trace: {
				/* 商品关注 */
				product: '0',
				/* 品牌关注 */
				brand: '0',
				/* 活动关注 */
				activity: '0',
				/* 浏览记录 */
				history: '0'
			},
			wallet: {
				/* 积分 */
				integral: '0',
				/* 优惠券 */
				coupon: '0',
				/* 红包 */
				redPacket: '0.00',
				/* 余额 */
				money: '0.00'
			}
		}
	});
	
	/**
	 * 图片高度样式
	 */
	const imageStyle = computed(() => {
		let navBarHeight = ctx.vuex_navBarHeight + 120;
		return `
			height: ${navBarHeight}px;
			width: 100%;
		`;
	});

	/**
	 * 标题样式
	 */
	const titleStyle = computed(() => {
		return `
			height: 52px;
			color: #ffffff;
			position: absolute;
			top: 12px;
			border-radius: 10px;
			width: 100%;
			text-align: center;
			font-size: 14px;
		`;
	});

	/**
	 * userPanel样式
	 */
	const userPanelStyle = computed(() => {
		let navBarHeight = ctx.vuex_navBarHeight + 30;
		return `
			top: ${navBarHeight}px;
		`;
	});

	onLoad(() => {
		console.log("onLoad 我是mine")
	})

	// 页面显示时执行
	onShow(() => {
		console.log("onShow 我是mine")
		// 获取公告最新三条信息
		if(uni.getStorageSync('lifeData').vuex_user){
			initAnnounceInfo();
		}
		
		fnInitData();
		if(uni.getStorageSync('lifeData').vuex_user){
			//初始化订单信息
			fnInitOrder();
		}
		
		if(uni.getStorageSync('lifeData').vuex_user){
			data.membType = uni.getStorageSync('lifeData').vuex_user.membType;
			data.isFrozen = uni.getStorageSync('lifeData').vuex_user.isFrozen;
		}
	})

	// 跳转登录页
	function toLogin(){
		uni.navigateTo({
			url: '/pages/login/login',
			animationType: 'fade-in'
		});
	}
	
	// 跳转订单页
	function fnGotoOrderPage(state){
		if(!ctx.vuex_hasLogin){
			uni.showToast({
			  title: '请登录后查看',
			  icon: 'none'
			})
			return
		}
		wx.navigateTo({
		  url: "/pages/order/order" + "?state=" + state,
		})
	}
  
	// 跳转页面通用方法
	function navigateTo(path){
		uni.navigateTo({
			url: path,
			animationType: 'fade-in'
		});
	}
	// 跳转设置
	function goSet(){
		if(!ctx.vuex_hasLogin){
			uni.showToast({
			  title: '请登录后查看',
			  icon: 'none'
			})
			return
		}
		uni.navigateTo({
		  url: "/pages/set/set",
		});
	}
	// 跳转产品问答
	function goHelp(){
		if(!ctx.vuex_hasLogin){
			uni.showToast({
			  title: '请登录后查看',
			  icon: 'none'
			})
			return
		}
		uni.navigateTo({
		  url: "/pages/help/help",
		});
	}
	// 跳转地址管理
	function goAddressList(){
		if(!ctx.vuex_hasLogin){
			uni.showToast({
			  title: '请登录后查看',
			  icon: 'none'
			})
			return
		}
		uni.navigateTo({
		  url: "/pages/address/list",
		});
	}
	
	//跳转企业微信
	function goCustomer(){
		if(!ctx.vuex_hasLogin){
			uni.showToast({
			  title: '请登录后查看',
			  icon: 'none'
			})
			return
		}
		// #ifndef APP-PLUS
		uni.showToast({
			title: '请在app打开',
			icon:"none"
		});
		// #endif
		let wechat = null
		plus.share.getServices(res => {
		 wechat = res.find(i => i.id === 'weixin')
			if (wechat) {
				wechat.openCustomerServiceChat({
					corpid: import.meta.env.VITE_WECHAT_CORPID,//企业ID
					url: import.meta.env.VITE_WECHAT_KEFU_URL,//客服地址
				}, src => {
					console.log("success:")
				}, err => {
					console.log("error:", err)
				})
			} else {
				uni.showToast({
					title: '当前环境不支持微信操作',
					icon:"error"
				});
			}
		});
	}

	// 初始化订单信息
	function fnInitOrder() {
		let param = {};
		param.platId = ctx.vuex_platId!=null?ctx.vuex_platId:1;
		param.membId = uni.getStorageSync('lifeData').vuex_membid;
		param.isSelOperateOrder = 1;
		countOrderInfo(JSON.stringify(param)).then(res => {
		  let retCode = res.retCode;
		  if (1 == retCode) { //success
			  data.orderInfoBo=res.obj
		  } else {
			fnShowErrorToast("操作错误，刷新重试");
		  }
		});
	}
  
	// 追溯码跳转
	function fnMytraceabilityCode() {
		console.log('点击追溯码');
		let type = data.membInfoBo.identityVerificationState;
		let membType = data.membInfoBo.membType;
		uni.navigateTo({
			url: "/pages/trace/from"
		});
	}
	
	// 防伪码跳转
	function fnMytraceabilityAnti() {
		// console.log('点击防伪码');
		// let type = data.membInfoBo.identityVerificationState;
		// let membType = data.membInfoBo.membType;
		uni.navigateTo({
		  url: "/pages/trace/antifake"
		});
	}
	
	// 获取最新三条公告信息
	function initAnnounceInfo(){
		let paramObj = {
			platId: ctx.vuex_platId!=null?ctx.vuex_platId:1,
			membId: uni.getStorageSync('lifeData').vuex_membid,
		}
		getAnnounceInfoThreeNew(JSON.stringify(paramObj)).then(res => {
			if(res.retCode == 1) {
				data.announceInfoList = res.objs;
			} else {
				console.log("请求错误");
			}
		}).catch(err => {
			uni.$u.toast(err.msg); 
		})
	}
	
	// 我的页面最新三条公告点击跳转
	function goAnnounceDetail(item)  {
		//获取当前公告ID
		let announceId = item.id;
		//获取已读还是未读0：未读；1：已读
		let isRead = item.isRead;
		
		if(isRead == 0) {
			let paramObj = {
				platId: ctx.vuex_platId!=null?ctx.vuex_platId:1,
				id: announceId,
				isRead: isRead,
				membId: uni.getStorageSync('lifeData').vuex_membid,
			};
			insertBaseAnnounceReadHistory(JSON.stringify(paramObj)).then(res => {
				if (res.retCode == 1) {
					uni.navigateTo({
					  url: "../announceDetail/announceDetail?id=" + announceId + "&isread=" + isRead,
					});
				} else {
					console.log("请求错误");
				}
			}).catch(err => {
				uni.$u.toast(err.msg); 
			})
		} else {
			//跳转公告详情
			uni.navigateTo({
			  url: "../announceDetail/announceDetail?id=" + announceId + "&isread=" + isRead,
			});
		} 
	}
	
	// 打开会员注册页面
	function fnOpenVipRegister(){
		uni.navigateTo({
			url: '../vipRegister/vipRegister?isUpgrade=0'
		})
	}
	// 补货升级
	function handleBtnRegisterTap() {
		console.log("===========补货升级")
		if(data.membType!=1){// 注册
			uni.navigateTo({
				url: '../vipRegister/vipRegister?isUpgrade=0'
			})
		}else{// 补货升级
			uni.navigateTo({
				url: '../vipRegister/vipRegister?isUpgrade=1'
			})
		}
	}

	// 点击个人信息
	function myPersonal() {
		secondData.value.goToType = 0;
		showAccountModal.value = true;
		secondData.value.secPasswordInputFocus = true;
	}
	
	// 点击我的客户
	function fnOpenMyTeam() {
		secondData.value.goToType = 1;
		showAccountModal.value = true;
		secondData.value.secPasswordInputFocus = true;
	}
	
	// 点击我的账户
	function fnMyAccount() {
		secondData.value.goToType = 2;
		showAccountModal.value = true;
		secondData.value.secPasswordInputFocus = true;
	}
	
	// 接收我的账户二级密码输入框数据
	function handlerInputPassWord(param) {
		data.inputSecPassword = param.inputSecondPassword;
		// secPasswordError: false
	}
	
	// 我的账户弹出框取消按钮
	function handlerOnClose() {
		data.inputSecPassword = null;// 清空二级密码值
		showAccountModal.value = false;
		secondData.value.secPasswordInputFocus = false;
		secondData.value.passwordError = false;
		secondData.value.passwordErrorMsg = ''
	}
	
	// 我的账户弹出框确认按钮
	function handlerOnConfirm() {
		// console.log("data.inputSecPassword=",data.inputSecPassword)
		//获取输入框二级密码数据
		const inputSecPassword = data.inputSecPassword;
		// 二级密码不能为空
		if(inputSecPassword == null || inputSecPassword == ""){
			uni.showToast({
				title: '请输入二级密码',
				icon: 'none'
			})
			return
		}
		
		//开始和后台接口二级密码对比校验
		let platId = 1;
		if(ctx.vuex_platId != undefined && ctx.vuex_platId != null && ctx.vuex_platId != "") {
			platId = ctx.vuex_platId;
		}
		let paramObj = {
			platId: platId,
			membId: uni.getStorageSync('lifeData').vuex_membid,
			membSecPassword: inputSecPassword,
		}
		
		checkSecPassWord(JSON.stringify(paramObj)).then(res => {
			if(res.retCode == 1) {
				showAccountModal.value = false;
				secondData.value.showSecPasswordModal = false;
				secondData.value.secPasswordInputFocus = false;
				secondData.value.passwordError = false;
				secondData.value.passwordErrorMsg = ''
				// 校验成功后清空二级密码
				data.inputSecPassword = null
				
				const gotoType = secondData.value.goToType;
				console.log("gotoType")
				console.log(gotoType)
				if(gotoType == 0) {
					uni.navigateTo({
						url: '../myPersonalInfo/myPersonalInfo'
					})
				} else if(gotoType == 1) {
					uni.navigateTo({
						url: '../myAccountAll/performanceRight?type=' + gotoType + '&isHidden=1'
					})
				} else if(gotoType == 2) {
					uni.navigateTo({
						url: '../myAccountAll/myAccountAll?type=' + gotoType
					})
				}
			} else {
				// 二级密码错误
				secondData.value.passwordError = true;
				secondData.value.passwordErrorMsg = '二级密码输入错误，请重新输入'
			}
		}).catch(err => {
			uni.$u.toast(err.msg); 
		})
	}

	/**
	 * 初始化会员信息
    */
	function fnInitData() {
		const membId = uni.getStorageSync('lifeData').vuex_membid;
		if (!membId) {
		  return;
		}

		const param = {
		  membId: membId,
		  platId: ctx.vuex_platId!=null?ctx.vuex_platId:1,
		  queryMaxLevel: 1
		};

		getMembInfoByIdApi(JSON.stringify(param)).then(res => {
			const retCode = res.retCode;
			let alert_msg = "";
			if (retCode === 1) {
				if (!res.obj) {
					alert_msg = "您的账号已经不存在";
					uni.showModal({
						title: '提示',
						content: alert_msg,
						showCancel: false,
						success: function (res) {
							uni.clearStorage();
							uni.navigateTo({
								url: "../login/login"
							});
						}
					});
					return;
				}
				// 更新数据
				data.isReplenish = res.obj.isReplenish;
				fnShowData(res);
			} else {
				fnShowErrorToast("操作错误，刷新重试");
			}
			uni.stopPullDownRefresh(); // 停止下拉刷新
		})
	}

	/**
     * 显示数据
     */
	function fnShowData(res) {
		let membUserName = '';
		if(!fnIsNull(res.obj.membUserName)){
			membUserName = res.obj.membUserName;
			if(membUserName.length>9){
				membUserName = membUserName.substring(0,9) + '...'
			}
		}else if(!fnIsNull(res.obj.membName)){
			membUserName = res.obj.membName;
			if(membUserName.length>9){
				membUserName = membUserName.substring(0,9) + '...'
			}
		}
    
		// 保存会员信息到存储
		try {
			const lifeData = uni.getStorageSync('lifeData') || {}
			lifeData.vuex_user = res.obj
			uni.setStorageSync('lifeData', lifeData)
		} catch (e) {
			console.error('保存用户信息失败:', e)
		}

		data.replenishTime = res.obj.replenishTime
    
		if(fnIsNull(res.obj.nextMembChiefGradeBo)){
			data.isShowMemb = false
		}else{
			data.isShowMemb = true
		}
    
		// 更新数据
		data.membInfoBo = res.obj
		data.membAccountBo = res.obj.membAccountBo
		data.membChiefGradeBoList = res.objs1
		data.membUserName = membUserName
		data.nextMembChiefGradeBo = res.obj.nextMembChiefGradeBo
		data.isWxCheck = res.obj.isWxCheck
		data.gradeType = res.obj.gradeType
		data.chiefLevel = res.obj.chiefLevel
		data.userChiefName = res.obj.chiefName
		data.gradeName = res.obj.gradeName
		data.membNum = res.obj.membNum
		data.samePhoneMembList = res.obj.samePhoneMembList
		data.membType = res.obj.membType
		data.canUpgrade = fnNvl(res.obj.gradeLevel, 0) < fnNvl(res.obj.maxGradeLevel, 0)
		data.isCompany = res.obj.isCompany
    
		if(fnIsNull(res.obj.headImgUrl) || res.obj.headImgUrl == undefined){
		  // 假设页面中有相应的ref或data属性
		  // data.isHide = true
		}else{
		  // data.isHide = false
		}
    
		//获取当前会员当前等级
		let chiefGradeId = res.obj.chiefGradeId;
		//会员已有级别
		if(chiefGradeId!=null && chiefGradeId!=''){//会员已有级别
			for (var i =0; i < res.objs1.length;i++) {
				if (chiefGradeId == res.objs1[i].chiefGradeId) {
					data.nowLevel = res.objs1[i]
					data.active = res.objs1[i].chiefLevel
					data.current = res.objs1[i].chiefLevel - 1
					break;
				}
		  }
		  //会员新注册没有级别
		}else{
			if(res.objs1 != null){
				data.nowLevel = res.objs1[0]
				data.active = 0
				data.current = 0
			}else{
				data.active = 0
				data.current = 0
			}
		}
		//初始化会员信息
		initShowMsg();
		//初始化分享配置
		// that.fnGetSysSet();
		// 判断是否需要显示完善信息节点
		const storedUser = uni.getStorageSync('lifeData').vuex_user || {}
		fnGetBaseSystemSetInfo();
	}
  
	/**
	 * 初始化显示会员信息提示
     */
	function initShowMsg() {
		let membInfoBo = data.membInfoBo;
		let alert_msg = "";
    
		if (!membInfoBo) { // 用户不存在
			alert_msg = "您的账号已经不存在";
		} else {
			if (membInfoBo.isStop == 1) { // 用户封停
				alert_msg = "您已被封停";
			}
			// if (membInfoBo.isFrozen == 1) { // 用户冻结
			// 	alert_msg = "您已被冻结";
			// 	fnClearAllMsg();
			// 	uni.showModal({
			// 		title: '提示',
			// 		content: '您已被冻结',
			// 		showCancel: false,
			// 		success: function(res) {
			// 			uni.clearStorage();
			// 			uni.navigateTo({
			// 				url: "../login/login"
			// 			});
			// 		}
			// 	});
			// 	return;
			// }
			if (membInfoBo.status == 1) { // 用户解除绑定
				alert_msg = "您已解除绑定";
				fnClearAllMsg();
				uni.showModal({
					title: '提示',
					content: '您已解除绑定',
					showCancel: false,
					success: function(res) {
						uni.clearStorage();
							uni.navigateTo({
							url: "../login/login"
						});
					}
				});
				return;
			}
			if (membInfoBo.isBondReturn == 1) { // 用户退保
				alert_msg = "您已退保";
				fnClearAllMsg();
				uni.showModal({
					title: '提示',
					content: '您已退保',
					showCancel: false,
					success: function(res) {
						uni.clearStorage();
						uni.navigateTo({
							url: "../login/login"
						});
					}
				});
				return;
			}
			if (membInfoBo.isBlackList == 1) { // 用户不可登陆
				fnClearAllMsg();
				uni.showModal({
					title: '提示',
					content: '账号已失效',
					showCancel: false,
					success: function(res) {
						uni.clearStorage();
						uni.navigateTo({
							url: "../login/login"
						});
					}
				});
				return;
			}
			if (membInfoBo.membLimitationSetBo != null && membInfoBo.membLimitationSetBo.isBlackList == 0) { // 用户不可登陆
				fnClearAllMsg();
				uni.showModal({
					title: '提示',
					content: '账号异常',
					showCancel: false,
					success: function(res) {
						uni.clearStorage();
						uni.navigateTo({
							url: "../login/login"
						});
					}
				});
				return;
			}
		}
		// 如果需要更新UI提示信息，可以在这里处理
		// data.alert_msg = alert_msg;
	}
	
	function fnClearAllMsg(){
		// 1. 先获取存储的lifeData数据
		const lifeData = uni.getStorageSync('lifeData') || {};
		// 2. 删除vuex_user字段
		if (lifeData.hasOwnProperty('vuex_user')) {
		  delete lifeData.vuex_user;
		  delete lifeData.vuex_hasLogin;
		  delete lifeData.vuex_membid;
		}
		ctx.$u.vuex('vuex_hasLogin', false);
		// 3. 重新存储处理后的lifeData
		uni.setStorageSync('lifeData', lifeData);
	}
  
	// 获取系统基础设置信息
	function fnGetBaseSystemSetInfo(){
		const param = {
			platId: ctx.vuex_platId!=null?ctx.vuex_platId:1,
		};

		getBaseSystemSetInfoByPlatId(JSON.stringify(param)).then(res => {
			data.sendAwardDate = res.obj.sendAwardDate
			data.extInfoUrl = res.obj.extInfoUrl
			data.corpId = res.obj.corpId
			data.replenishTimeMoon = res.obj.replenishTimeMoon

			// 正确的日期计算逻辑
			const replenishTimeMoon = res.obj.replenishTimeMoon
			const storedUser = uni.getStorageSync('lifeData').vuex_user || {}
			const replenishTime = storedUser.replenishTime

			// 1. 先检查并解析replenishTime时间戳字符串
			const replenishDate = new Date(replenishTime);
			if (isNaN(replenishDate.getTime())) {
				console.error('无效的replenishTime格式:', replenishTime);
				return;
			}

			// 2. 计算目标日期：在replenishTime基础上加上指定的月份
			const targetDate = new Date(replenishDate);
			// 加上月份（注意JavaScript月份是0-11，但setMonth会自动处理溢出）
			targetDate.setMonth(targetDate.getMonth() + Number(replenishTimeMoon));

			// 3. 处理今天的日期（只比较年月日）
			const today = new Date();
			today.setHours(0, 0, 0, 0);

			// 4. 同样处理目标日期的时间部分
			targetDate.setHours(0, 0, 0, 0);

			const membType = storedUser.membType

			// 计算显示条件
			const isShowReplenish = (membType == 1 && data.isCompany === 0) &&  (data.isReplenish == 0 && targetDate >= today)
			data.isShowReplenish = isShowReplenish
			console.log("---------------isShowReplenish",isShowReplenish)
		}).catch(err => {
			fnShowErrorToast("系统异常，请刷新重试")
		});
	}


	/**
	 * 模拟onShow方法
	 */
	function onHandleShow() {
		console.log("onHandleShow 我是mine")
	}
	
	function fnGoToLogin(){
		//不存在则跳转至登录页
		uni.navigateTo({
		  url: "/pages/login/login",
		})
	}

	// 将 onHandleShow 暴露给父组件
	defineExpose({ onHandleShow });
</script>

<style lang="scss" scoped>
	.my-box {
		position: relative;
		.user-panel-box {
			height: 115px;
			background-color: #ffffff;
			position: absolute;
			top: 110px;
			left:2%;
			border-radius: 10px;
			width: 96%;
			margin-bottom: 10px;
			
		}
	.u-m-r-20 {
		margin-top:-30px;
	}
	.u-font-lg {
		display: block;
		font-size: 18px;
		font-weight: bold;
		float: left;
		overflow: hidden;
		line-height: 32px;
	}
	.level {
		float: left;
		color: #821f15!important;
		font-size: 17px;
		margin-left:10px;
		font-weight: bold;
		line-height: 30px;
		
	}
	.u-flex{
		display:block!important ;
	}
	.num {
		position:absolute;
		top:65px;
    font-size: 36rpx;
		font-weight: bold;
		margin-bottom: 20px;
		// margin-left: 20px;
		width: 100%;
		padding: 0 30rpx;
	}
	
	.bhsj {
		color:#ff8b00;
		float:right;
		// margin-right: 10px;
		font-size:17px;
		font-weight: normal!important;
		
	}
  .nav_list_num{
    min-width: 24rpx;
    height: 24rpx;
    text-align: center;
    padding: 0 5rpx;
    line-height: 24rpx;
    border-radius: 24rpx;
    font-size: 20rpx;
    color: #ffffff;
    background-color: #ff5656;
    position: absolute;
    right: 30rpx;
    top: -5rpx;
    box-sizing: border-box;
  }
	.nav_my_top_tit{
		color: #333;
		font-weight: bold;
		font-size: 16px;
		}
	
	.go_to_icon{
	  width: 6px;
	  height: 10px;
	  margin-left: 10rpx;
	  margin-bottom: 0rpx;
	}
	
	.nav_list{
	  flex: 1;
	  text-align: center;
	  font-size: 16px;
	  color: #333333;
	  padding-top: 20rpx;
	  padding-bottom: 20rpx;
	}
	
	.nav_list image {
		width:96%;
		margin:0 auto;
		height: 130px;
	}
	.u-section__title {
		 
		font-size: 18px!important;
		font-weight: bold;
		line-height: 2!important;
		
	}
	
	
		.user-card-box {
			margin: 0 12rpx;
			padding: 20rpx 20rpx;
			border-radius: 16rpx;
			background-color: #ffffff;
		}
	
		.trace-card-box {
			margin: 0 12rpx;
			padding: 10rpx 10rpx;
			border-radius: 16rpx;
			background-color: #ffffff;
		}
	
		.panel-box {
			background-color: #ffffff;
			width: 96%;
			margin: 0 auto;
			border-radius: 10px;
			padding:10px;
	
			.panel-header {
				padding-left: 10rpx ;
				border-bottom: 1rpx solid #F5F5F5;
			}
			.panel-header title {
				font-size: 18px;
			}
	
			.panel-main {
				padding: 10rpx 0;
			}
		}
	
		.card-box {
			padding: 10rpx 0;
			background-color: #ffffff;
	
			.all-order {
				position: relative;
				.cut-off-line {
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					left: 0rpx;
					width: 30rpx;
					height: 160rpx;
				}
			}
		}
	
		.other-panel-box {
			.panel-main {
				padding: 10rpx 0;
			}
		}
	
		.other-card-box {
			margin: 0 12rpx;
			padding: 10rpx 0;
			border-radius: 16rpx;
			background-color: #ffffff;
		}
		
		.nav_my_body{
			width: calc(100% - 16px);
			margin: 10px auto 0;
			border-radius: 20rpx;
			background-color: #fff;
		}
		
		.nav_my_top{
			height: 70rpx;
			line-height: 70rpx;
			/* border-bottom: 1px solid #eff0f5; */
			padding: 0 10px;
		}
		
		.nav_my_order_all{
			float: right;
			font-size: 26rpx;
			color: #999999;
		}
		
		.nav_my_top_tit{
			color: #333;
			font-weight: bold;
			font-size: 16px;
		}
		
		.go_to_icon{
			width: 6px;
			height: 10px;
			margin-left: 10rpx;
			margin-bottom: 0rpx;
		}
	}
</style>